import { CalculatorInputs, SliderConfig } from '../types/calculator';

// Fixed constants
export const WORKING_DAYS_PER_YEAR = 240; // 48 weeks × 5 days
export const HOURS_PER_YEAR = 2080; // 250 days × 8 hours
export const FTE_HOURS_PER_YEAR = 1976; // For annualized FTE calculation
export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = 480; // 8 hours
export const MARKET_COFFEE_PRICE = 5.50; // Market price per cup

// Sustainability factors
export const CO2_PER_CUP = 0.026; // kg
export const WATER_PER_CUP = 0.2889875; // litres
export const WASTE_PER_CUP = 0.00615; // kg (waste diverted)
export const WASTE_AVOIDED_PER_CUP = 0.0035; // kg (bin equivalent)
export const ENERGY_PER_CUP = 0.4739; // kJ
export const PLASTIC_PER_CUP = 0.00165; // kg
export const TREES_PER_CUP = 0.00125; // trees planted equivalent
export const CO2_PER_CAR_KM = 0.404; // kg CO2 per km
export const KM_CONVERSION = 1.60934; // miles to km conversion

// Default input values
export const DEFAULT_INPUTS: CalculatorInputs = {
  employeeCount: 250,
  avgSalary: 80000,
  breakDuration: 15,
  cupsPerEmployee: 1.5,
  officeDaysPerWeek: 5,
  subsidyPercent: 2.5,
};

// Slider configurations
export const SLIDER_CONFIGS: Record<keyof CalculatorInputs, SliderConfig> = {
  employeeCount: {
    min: 100,
    max: 2000,
    step: 10,
    default: 250,
    label: 'Number of Employees',
    helperText: 'Total employees in workplace',
    format: 'number',
  },
  avgSalary: {
    min: 50000,
    max: 250000,
    step: 5000,
    default: 80000,
    label: 'Average Annual Salary',
    helperText: 'Average employee salary (AUD)',
    format: 'currency',
  },
  breakDuration: {
    min: 0,
    max: 30,
    step: 5,
    default: 15,
    label: 'Average Break Duration',
    helperText: 'Time employees spend leaving workplace for coffee (minutes)',
    format: 'number',
  },
  cupsPerEmployee: {
    min: 0,
    max: 5,
    step: 0.5,
    default: 1.5,
    label: 'Daily Cups per Employee',
    helperText: 'Average cups per employee per day',
    format: 'decimal',
  },
  officeDaysPerWeek: {
    min: 1,
    max: 5,
    step: 1,
    default: 5,
    label: 'Office Days per Week',
    helperText: 'How many days staff come into the office',
    format: 'number',
  },
  subsidyPercent: {
    min: 0,
    max: 5.5,
    step: 0.25,
    default: 2.5,
    label: 'Company Subsidy',
    helperText: 'Amount subsidised per coffee (avg cost ~$5.50)',
    format: 'currency',
  },
};

// Time period multipliers (based on 240 working days per year)
export const TIME_MULTIPLIERS = {
  day: 1,
  week: 5, // 5 working days per week
  month: 20, // 240 / 12
  quarter: 60, // 240 / 4
  year: 240,
};

// Time period labels
export const TIME_PERIOD_LABELS = {
  day: 'Daily Figures',
  week: 'Weekly Figures',
  month: 'Monthly Figures',
  quarter: 'Quarterly Figures',
  year: 'Yearly Figures',
};
